// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper.wrapper--login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100% - 65px);
  padding: 0;
}

.logo-header {
  height: 5em;
}

.logo-header img {
  height: 25px;
  width: 165px;
}

.login-page .description {
  margin-bottom: 28px;
  font-size: 1.2rem;
  max-width: 30rem;
  text-align: center;
}

.login-page .autorization-form {
  height: fit-content;
  max-width: 476px;
  width: 100%;
  background: white;
  padding: 17.5px 38px 35px;
  border-radius: 6px;
}

.login-page .show-password-button {
  position: relative;
  align-self: flex-end;
  bottom: 42px;
}

.login-page .error-color {
  border-color: red;
}

.login-page .error-message {
  color: red;
  margin-top: 16px;
  font-style: italic;
  text-align: center;
}

.autorization-form__message {
  font-weight: 700;
}

.autorization-form__hr {
  border: none;
  color: var(--main-bg-color);
  background-color: var(--main-bg-color);
  height: 2px;
}

.autorization-form__submit {
  text-transform: none;
  width: inherit;
  margin-top: 16px;
  background: #4982c5;
  color: white;
  border: unset;
  border-radius: 5px;
  height: 30px;
}

.autorization-form__input {
  box-sizing: border-box;
  margin-top: 16px;
  display: block;
  width: inherit;
  border-radius: 5px;
  height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EAGvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".wrapper.wrapper--login-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: -moz-calc(100% - 65px);\n  height: -webkit-calc(100% - 65px);\n  height: calc(100% - 65px);\n  padding: 0;\n}\n\n.logo-header {\n  height: 5em;\n}\n\n.logo-header img {\n  height: 25px;\n  width: 165px;\n}\n\n.login-page .description {\n  margin-bottom: 28px;\n  font-size: 1.2rem;\n  max-width: 30rem;\n  text-align: center;\n}\n\n.login-page .autorization-form {\n  height: fit-content;\n  max-width: 476px;\n  width: 100%;\n  background: white;\n  padding: 17.5px 38px 35px;\n  border-radius: 6px;\n}\n\n.login-page .show-password-button {\n  position: relative;\n  align-self: flex-end;\n  bottom: 42px;\n}\n\n.login-page .error-color {\n  border-color: red;\n}\n\n.login-page .error-message {\n  color: red;\n  margin-top: 16px;\n  font-style: italic;\n  text-align: center;\n}\n\n.autorization-form__message {\n  font-weight: 700;\n}\n\n.autorization-form__hr {\n  border: none;\n  color: var(--main-bg-color);\n  background-color: var(--main-bg-color);\n  height: 2px;\n}\n\n.autorization-form__submit {\n  text-transform: none;\n  width: inherit;\n  margin-top: 16px;\n  background: #4982c5;\n  color: white;\n  border: unset;\n  border-radius: 5px;\n  height: 30px;\n}\n\n.autorization-form__input {\n  box-sizing: border-box;\n  margin-top: 16px;\n  display: block;\n  width: inherit;\n  border-radius: 5px;\n  height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
